import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/user/comment_ico.png'
import _imports_1 from '@/assets/user/good_ico.png'
import _imports_2 from '@/assets/user/bad_ico.png'
import _imports_3 from '@/assets/user/reply_ico.png'


const _hoisted_1 = { class: "bo_comment_box" }
const _hoisted_2 = { class: "bo_comment_tit" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_4 = { class: "bo_comment" }
const _hoisted_5 = ["data-list"]
const _hoisted_6 = { class: "comment_info" }
const _hoisted_7 = { class: "user_id" }
const _hoisted_8 = { class: "write_date" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", null, null, -1)
const _hoisted_13 = [
  _hoisted_10,
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "comment_content" }
const _hoisted_18 = { class: "cc_tit" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { key: 2 }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "cc_good_bad_btns" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1)
const _hoisted_26 = ["onClick"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1)
const _hoisted_28 = { class: "reply_box" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "reply_ico" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    alt: ""
  })
], -1)
const _hoisted_31 = { class: "comment_info" }
const _hoisted_32 = { class: "user_id" }
const _hoisted_33 = { class: "write_date" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", null, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("i", null, null, -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("i", null, null, -1)
const _hoisted_38 = [
  _hoisted_35,
  _hoisted_36,
  _hoisted_37
]
const _hoisted_39 = ["id"]
const _hoisted_40 = ["onClick"]
const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_42 = ["onClick"]
const _hoisted_43 = { class: "comment_content" }
const _hoisted_44 = { class: "cc_tit" }
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { key: 1 }
const _hoisted_47 = { key: 2 }
const _hoisted_48 = {
  key: 0,
  class: "reply_more_btn"
}
const _hoisted_49 = ["onClick"]
const _hoisted_50 = { class: "reply_input_box" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    alt: ""
  })
], -1)
const _hoisted_52 = ["id", "onKeydown"]
const _hoisted_53 = ["onClick"]
const _hoisted_54 = ["onClick"]
const _hoisted_55 = { class: "bo_comment_write" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("p", null, "댓글 작성", -1)
const _hoisted_57 = { class: "comment_write_input" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalComponent = _resolveComponent("ModalComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("span", null, [
          _createTextVNode("댓글 [ "),
          _createElementVNode("b", null, _toDisplayString(_ctx.$props.cntComment), 1),
          _createTextVNode("건 ]")
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.comment.data, (item, idx) => {
            return (_openBlock(), _createElementBlock("li", {
              "data-list": `comment` + item.idx
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", null, [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(item.name) + " [" + _toDisplayString(item.childCnt) + "건]", 1),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(item.updateDate ?
                                    $setup.formatDate(item.updateDate) :
                                    $setup.formatDate(item.createDate)), 1)
                ]),
                (item.meIdx === $setup.user.userInfo.idx && item.state === 1)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "comment_info_btn",
                      onClick: ($event: any) => ($setup.showModifyBtn(item.idx))
                    }, _hoisted_13, 8, _hoisted_9))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: "comment_modify_box",
                  style: _normalizeStyle($setup.comment.isModifyBox[item.idx] ? 'display:block' : 'display: none;')
                }, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "modify_btn",
                    onClick: ($event: any) => ($setup.modifyComment(item.idx, idx))
                  }, "수정", 8, _hoisted_14),
                  _hoisted_15,
                  _createElementVNode("button", {
                    type: "button",
                    class: "modify_btn",
                    onClick: ($event: any) => ($setup.deleteCommentBtn(item.idx))
                  }, "삭제", 8, _hoisted_16)
                ], 4)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  (item.state === 0)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_19, "관리자에 의해 삭제된 댓글입니다."))
                    : _createCommentVNode("", true),
                  (item.state === 1)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(item.content), 1))
                    : _createCommentVNode("", true),
                  (item.state === 2)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_21, "사용자에 의해 삭제된 댓글입니다."))
                    : _createCommentVNode("", true),
                  (item.state === 1)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 3,
                        type: "button",
                        class: "write_reply_btn",
                        onClick: ($event: any) => ($setup.showReCommentInput(idx))
                      }, "댓글달기", 8, _hoisted_22))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "good_btn",
                    onClick: ($event: any) => ($setup.commentGood(item.idx, idx))
                  }, [
                    _hoisted_25,
                    _createElementVNode("span", null, _toDisplayString(item.cntGood), 1)
                  ], 8, _hoisted_24),
                  _createElementVNode("button", {
                    type: "button",
                    class: "bad_btn",
                    onClick: ($event: any) => ($setup.commentBad(item.idx, idx))
                  }, [
                    _hoisted_27,
                    _createElementVNode("span", null, _toDisplayString(item.cntBad), 1)
                  ], 8, _hoisted_26)
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.reComment.data[idx], (reItem, reIdx) => {
                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                      (reItem.parentIdx === item.idx)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_29, [
                            _hoisted_30,
                            _createElementVNode("div", _hoisted_31, [
                              _createElementVNode("div", null, [
                                _createElementVNode("span", _hoisted_32, _toDisplayString(reItem.name), 1),
                                _createElementVNode("span", _hoisted_33, _toDisplayString(reItem.updateDate ?
                                                    $setup.formatDate(reItem.updateDate) :
                                                    $setup.formatDate(reItem.createDate)), 1)
                              ]),
                              (reItem.meIdx === $setup.user.userInfo.idx && reItem.state === 1)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    type: "button",
                                    class: "comment_info_btn",
                                    onClick: ($event: any) => ($setup.showReModifyBtn(reItem.idx))
                                  }, _hoisted_38, 8, _hoisted_34))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", {
                                class: "comment_modify_box",
                                id: 'reComment' + reItem.idx
                              }, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "modify_btn",
                                  onClick: ($event: any) => ($setup.modifyReComment(idx, reIdx))
                                }, "수정", 8, _hoisted_40),
                                _hoisted_41,
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "modify_btn",
                                  onClick: ($event: any) => ($setup.deleteCommentBtn(reItem.idx))
                                }, "삭제", 8, _hoisted_42)
                              ], 8, _hoisted_39)
                            ]),
                            _createElementVNode("div", _hoisted_43, [
                              _createElementVNode("div", _hoisted_44, [
                                (reItem.state === 0)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_45, "관리자에 의해 삭제된 댓글입니다."))
                                  : _createCommentVNode("", true),
                                (reItem.state === 1)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_46, _toDisplayString(reItem.content), 1))
                                  : _createCommentVNode("", true),
                                (reItem.state === 2)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_47, "사용자에 의해 삭제된 댓글입니다."))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 256))
                ]),
                ($setup.reComment.isMoreReComment[idx])
                  ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: ($event: any) => ($setup.getReComment(item.idx, idx))
                      }, "더보기", 8, _hoisted_49)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: "reply_write_box",
                  style: _normalizeStyle($setup.comment.isReCommentBox[idx] ? 'display:block' : '')
                }, [
                  _createElementVNode("div", _hoisted_50, [
                    _hoisted_51,
                    _createElementVNode("input", {
                      type: "text",
                      id: 'reCommentWrite' + idx,
                      onKeydown: _withKeys(($event: any) => ($setup.addReCommentBtn(item.idx, idx)), ["enter"])
                    }, null, 40, _hoisted_52),
                    ($setup.reComment.isBtnType === 0)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          onClick: ($event: any) => ($setup.addReCommentBtn(item.idx, idx))
                        }, "등록", 8, _hoisted_53))
                      : (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          type: "button",
                          onClick: ($event: any) => ($setup.modifyReCommentBtn(idx))
                        }, "수정", 8, _hoisted_54))
                  ])
                ], 4)
              ])
            ], 8, _hoisted_5))
          }), 256))
        ])
      ]),
      _createElementVNode("div", _hoisted_55, [
        _hoisted_56,
        _createElementVNode("div", _hoisted_57, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.comment.myComment) = $event)),
            id: "commentWrite"
          }, null, 512), [
            [_vModelText, $setup.comment.myComment]
          ]),
          ($setup.comment.isBtnType === 0)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.addComment && $setup.addComment(...args)))
              }, "등록"))
            : (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "button",
                onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.modifyCommentBtn()))
              }, "수정"))
        ])
      ])
    ]),
    _createVNode(_component_ModalComponent, {
      show: $setup.state.isModalOpen,
      yes: $setup.modal.confirm,
      no: $setup.modal.cancel,
      content: $setup.modal.content,
      onClose: $setup.modalClose
    }, null, 8, ["show", "yes", "no", "content", "onClose"])
  ], 64))
}